import React, { FC } from "react";
import { Icon } from "../icon/icon";
import styles from './styles/fancy-card-style.module.scss';

type TWidth = 'full' | 'auto';

interface IFancyCard {
    width?: TWidth,
    text: string,
    isActive?: boolean,
    iconSrc?: string,
    onClick?: () => void,
    isHover?: boolean,
    clearCursor?: boolean,
    disableWrapInMobile?: boolean
}

const FancyCard: FC<IFancyCard> = ({ disableWrapInMobile = false, clearCursor = false, isActive = false, text, iconSrc, onClick, isHover = true, width = 'full' }) => {
    return (
        <div className="">
            <div onClick={onClick} className={`${width === 'full' ? "w-full" : "w-auto"} py-2 px-6 rounded-md ${clearCursor ? "" : "cursor-pointer"} ${isHover ? "transition-opacity hover:opacity-50" : ""} ${styles.fancyCardRounded} ${isActive ? styles.active : styles.fancyCardBg} `}>
                <div className="flex items-center justify-center">
                    {
                        iconSrc && (
                            <div className="w-6 flex items-center justify-center ml-1">
                                <Icon src={iconSrc} width={20} height={20} />
                            </div>
                        )
                    }
                    <p className={`${isActive ? "text-white" : "text-color-l1"} w-11/12 md:w-auto break-words ${disableWrapInMobile ? "md:whitespace-nowrap" : "whitespace-nowrap"}`}>{text}</p>

                </div>
            </div>
        </div>
    )
}

export default React.memo(FancyCard)